import { types } from "mobx-state-tree";
import feedbackStore from "./stores/feedback";

const NiesStore = types.model("NiesStore", {
	feedbackStore: types.optional(feedbackStore, {})
});

export default NiesStore.create({});
